export const services = [
    {
        id: "drone-cinema-suite",
        slug: "drone-cinema-suite",
        category: "drone",
        cardTitle: "DRONE",
        cardSummary: "Üst segment lansmanlar için sinematik uçuş prodüksiyonu ve gökyüzü anlatımı.",
        title: "Drone Sinematografisi ve Uçuş Prodüksiyonu",
        intro: "Premium gayrimenkul ve peyzaj lansmanlarını RTK destekli uçuş planları ve sinematik CG entegrasyonu ile sahneye taşıyoruz. Drone footage, storyboard, ses ve renk sürecini tek ekipte topluyoruz.",
        focusPoints: [
            "Masterplan ve karma kullanım lansmanları için 6K/8K sinematik reel setleri",
            "Resort ve villa projeleri için FPV + ağır lift kombinasyonlu fly-through senaryoları",
            "Yatırımcı ve satış sunumlarına yönelik planimetrik çekimler ve storyboard onayları"
        ],
        highlights: [
            "RTK tabanlı uçuş izin planlama ve güvenlik koordinasyonu",
            "Creative treatment, shot list ve moodboard onayı",
            "Set günü görüntü denetimi ve LUT oluşturma"
        ],
        deliverables: [
            "RAW/ProRes ve LUT setleriyle birlikte sinematik reel",
            "Storyboard + shot log ile entegre prodüksiyon dosyası",
            "CG entegrasyonunu hızlandıran tracking ve metadata paketleri"
        ],
        process: [
            "Keşif, izin ve RTK koordinat planlama",
            "Storyboard, shot list ve ekipman seçimi",
            "Çekim günü: FPV + ağır lift eş zamanlı kayıt",
            "Color mastering, ses tasarımı ve final teslim"
        ],
        tools: ["DJI Inspire 3", "Freefly Alta X", "Blackmagic Resolve"],
        faq: [
            {
                question: "Uçuş izinleri ve sigorta süreçlerini kim yönetiyor?",
                answer: "Yerel otoritelerden gereken izinleri ve sigorta süreçlerini biz takip ediyoruz; işverenin mevcut belgeleri varsa entegrasyon sağlıyoruz."
            },
            {
                question: "Çekim sonrası CG üretim akışına nasıl aktarım yapılıyor?",
                answer: "Tüm footage'ı LUT, metadata ve referans karelerle birlikte teslim ediyor, Supabase üzerinden prodüksiyon klasörlerini paylaşıyoruz."
            }
        ],
        ctaLabel: "Drone prodüksiyon planla",
        ctaUrl: "mailto:studio@modelerman.com?subject=Drone%20Sinematografisi",
        orderIndex: 0,
        published: true
    },
    {
        id: "interior-visualization",
        slug: "interior-visualization",
        category: "interior",
        cardTitle: "İÇ MEKÂN",
        cardSummary: "Lobi, ofis ve hospitality sahneleri için fotogerçekçi iç mekân görselleştirme.",
        title: "İç Mekân Mimari Görselleştirme",
        intro: "Konut, ofis ve hospitality projelerinde malzeme paleti, ışık dili ve kullanıcı akışını aynı sahnede buluşturuyoruz. Drone footage ile iç mekân kurgusunu eşleyerek satış galerisi ve dijital kanallarda tutarlı bir deneyim sunarız.",
        focusPoints: [
            "Otel ve rezidans lobileri için gün/gece lookdev varyasyonları",
            "Kurumsal ofis ve çalışma alanlarında kullanıcı akışı storyboard'ları",
            "Showroom ve perakende konseptlerinde ürün odaklı mikro sahneler"
        ],
        highlights: [
            "Malzeme paleti ve mobilya varyasyonlarını aynı üretim akışında yönetme",
            "360° sanal tur ve VR panoramaları için optimize içerik",
            "Drone footage ile iç-dış bağlantıları güçlendiren eşleşmeler"
        ],
        deliverables: [
            "Hero render seti (gündüz/gece + detay sahneleri)",
            "30-45 sn animasyon veya walkthrough",
            "VR/360 tur ve satış ekranları için farklı oranlarda çıktı"
        ],
        process: [
            "Moodboard, malzeme ve stil onayı",
            "Alan yerleşimi + kamera rotası planlama",
            "Lookdev, ışık senaryosu ve animasyon üretimi",
            "Color grading, ses tasarımı ve teslim"
        ],
        tools: ["3ds Max • Corona", "Unreal Engine", "Adobe Substance 3D"],
        faq: [
            {
                question: "Birden fazla malzeme seçeneğini aynı sahnede gösterebilir miyiz?",
                answer: "Evet, varyant yönetimini node tabanlı kuruyoruz. Tek sahneden farklı malzeme ve mobilya kombinasyonları alabilirsiniz."
            }
        ],
        ctaLabel: "İç mekân brifi gönder",
        ctaUrl: "mailto:studio@modelerman.com?subject=İç%20Mekan%20Görselleştirme",
        orderIndex: 1,
        published: true
    },
    {
        id: "exterior-visualization",
        slug: "exterior-visualization",
        category: "exterior",
        cardTitle: "DIŞ MEKÂN",
        cardSummary: "Kentsel cephe, karma kullanım ve kamusal alan projeleri için dış mekân anlatımı.",
        title: "Dış Mekân Mimari Görselleştirme",
        intro: "Farklı ölçeklerdeki kent projelerinde fasad, sokak seviyesi ve kuş bakışı sahneleri tek paket halinde üretiriz. Güneş-gölge analizi ve malzeme varyasyonlarıyla yatırım kararlarını hızlandırırız.",
        focusPoints: [
            "Kentsel cephe yenilemelerinde gece-gündüz ışık senaryoları",
            "Karma kullanım komplekslerinde kamusal alan + ulaşım entegrasyonu",
            "Kıyı ve rekreasyon projelerinde iklim odaklı malzeme testleri"
        ],
        highlights: [
            "Hero, bird-eye ve street-level açılarını aynı sahnede sürdürme",
            "Güneş saatleri ve gölge etkilerini karşılaştırmalı sunma",
            "Materyal ve peyzaj varyasyonları için parametrik setup"
        ],
        deliverables: [
            "Farklı saat ve hava koşullarında 8K render setleri",
            "Uçuş-sürüş simülasyonlarını içeren sinematik walkthrough",
            "Kitle ve malzeme seçeneklerini özetleyen karar panosu"
        ],
        process: [
            "Arazi verisi ve kentsel bağlam toplama",
            "Kamera rotası, güneş senaryosu ve malzeme varyant planı",
            "CG üretim, crowd ve taşıt simülasyonu",
            "Color mastering, overlay ve teslim"
        ],
        tools: ["Unreal Engine", "Houdini", "Adobe After Effects"],
        faq: [
            {
                question: "Materyal değişikliklerini daha sonra güncelleyebilir miyiz?",
                answer: "PBR temelli kütüphanemiz sayesinde fasad değişikliklerini hızlıca revize edip render alabiliyoruz."
            }
        ],
        ctaLabel: "Dış mekân brifi paylaş",
        ctaUrl: "mailto:studio@modelerman.com?subject=Dış%20Mekan%20Görselleştirme",
        orderIndex: 2,
        published: true
    },
    {
        id: "landscape-visualization",
        slug: "landscape-visualization",
        category: "landscape",
        cardTitle: "PEYZAJ",
        cardSummary: "Okuldan villa peyzajına kadar farklı ölçeklerde detaylı peyzaj anlatımı.",
        title: "Peyzaj Tasarım ve Görselleştirme",
        intro: "Arazi topoğrafyasını, bitki seçimini ve kullanıcı senaryolarını drone verisiyle eşleyerek sahneye taşıyoruz. Her segment için saha hassasiyetini koruyan görselleştirme paketleri üretiriz.",
        focusPoints: [
            "Okul kampüsü peyzajı – güvenli erişim rotaları, aktivite avluları ve sürdürülebilir drenaj çözümleri",
            "Hastane kampüsü – iyileştirici yeşil alanlar, ambulans yaklaşımı ve gölgelendirme senaryoları",
            "Kamusal park – erişilebilir rota planları, peyzaj mobilya yerleşimi ve sezonluk bitkilendirme",
            "Konut bahçesi – site sosyal alanları, su öğesi entegrasyonu ve bakım planı görselleri",
            "Villa peyzajı – özel havuz, teras kotları ve mahremiyet odaklı yeşil perde çözümleri"
        ],
        highlights: [
            "Drone fotogrametrisi ile saha verisini doğrudan peyzaj modeline aktarma",
            "Mevsimsel varyasyonlar ve gece-gündüz ışık paketleri",
            "Bitki envanteri, bakım planı ve sulama diyagramlarını tek paket halinde sunma"
        ],
        deliverables: [
            "Master plan still seti ve animasyon breakdown",
            "Bitki yerleşim ve sert zemin overlay'leri",
            "Crowd sim ile yaşam akışını anlatan sinematik sekans"
        ],
        process: [
            "Topoğrafya ve brief verisinin toplanması",
            "Segment bazlı senaryo ve kamera planı",
            "Peyzaj modelleme, bitki kurgusu ve animasyon",
            "Color mastering, açıklama panosu ve teslim"
        ],
        tools: ["RealityCapture", "SpeedTree", "Twinmotion"],
        faq: [
            {
                question: "Peyzaj verilerini üçüncü kişilerle paylaşmadan önce nasıl koruyorsunuz?",
                answer: "Projeye özel paylaşımlarda veriyi anonimleştiriyor veya gerekli izinleri alıyoruz. Tüm dosyalar Supabase üzerinde rol tabanlı olarak tutuluyor."
            },
            {
                question: "Bakım planı ve bitki pasaportlarını görselleştirebilir misiniz?",
                answer: "Evet, peyzaj maintenance planlarını infografik overlay olarak hazırlayıp render setine ekliyoruz."
            }
        ],
        ctaLabel: "Peyzaj brifi gönder",
        ctaUrl: "mailto:studio@modelerman.com?subject=Peyzaj%20Görselleştirme",
        orderIndex: 3,
        published: true
    }
];
